export const classes = [
  { torrepizza: 'compact-wrapper' }
];